export default "__VITE_ASSET__ZlGtUo2A__"